// extracted by mini-css-extract-plugin
module.exports = {"container":"resourceCircle_container__2ryHa","isPressed":"resourceCircle_isPressed__1L-I3"};